import { CLEAR_MEDICAMENT_SUGGESTIONS, SEARCH_MEDICAMENT_SUCCESS } from 'FRONTEND/actions/constants';

const initialState = {
  suggestions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_MEDICAMENT_SUCCESS:
      return { ...state, suggestions: action.payload.results };

    case CLEAR_MEDICAMENT_SUGGESTIONS:
      return { ...state, suggestions: [] };
    default:
      return state;
  }
};
